import React from 'react';
import ReactDOM from 'react-dom';
import Home from './Pages/Home';
import { BrandDetailsProvider } from 'dw-au-react-components';
import { ContentfulProvider } from './Context/Contentful';
import { UserProvider } from './Context/User';
import { CartProvider } from './Context/CartContext';

const App = () => {
	return (
		<BrandDetailsProvider brandTag='wpe'>
			<UserProvider>
				<ContentfulProvider>
					<CartProvider>
						<Home />
					</CartProvider>
				</ContentfulProvider>
			</UserProvider>
		</BrandDetailsProvider>
	);
};

ReactDOM.render(<App />, document.getElementById('landing__page'));
